import { Display } from '@/components/Display/Display';
import { ImageViewer } from 'antd-mobile';
import { useState } from 'react';
import { Image } from 'antd-mobile';
import errImgage from '@/assets/images/usual/errImg.webp';
import s from './style.module.scss';
import { forwardRef, useImperativeHandle, useRef } from 'react';
const MobileImgage = ({ file, errImg, errClassName, className, canClickImage = true }, ref) => {
    const [isError, setIsError] = useState(false);
    const [visible, setVisible] = useState(false);
    const onClickImage = () => {
        if (!canClickImage) {
            return;
        }
        setVisible(true);
    };
    const openImg = () => {
        setVisible(true);
    };
    useImperativeHandle(ref, () => {
        return {
            openImg
        };
    });
    const onError = () => {
        setIsError(true);
    };
    return (
        <>
            <Display show={!isError && file?.file_url}>
                <img
                    fit="cover"
                    onClick={onClickImage}
                    // style={{
                    //     borderRadius: '8px',
                    //     overflow: 'hidden'
                    // }}
                    className={`${s['preview-img']} ${className}`}
                    src={file?.file_url}
                    preview={file?.file_url}
                    onError={onError}
                ></img>
            </Display>
            <Display show={isError || !file?.file_url}>
                <div className={`${s['err-img-wrap']} ${errClassName}`} src={errImg}>
                    <img src={errImgage || errImg} />
                </div>
            </Display>
            <ImageViewer
                image={file?.file_url}
                visible={visible}
                onClose={() => {
                    setVisible(false);
                }}
            />
        </>
    );
};
export default forwardRef(MobileImgage);
